module.exports = __webpack_public_path__ + "static/media/رحلات مائية في الأنهار والبحيرات.1f34aef0.jpg";